import { getStore } from '../store/store';

export default function shouldInitCalendarCloudSettings(): boolean {
    const store = getStore();

    if (!store) {
        return true;
    }

    if (
        store.shouldEventsEndEarly == null ||
        store.shortenEventScope == null ||
        store.endShortEventsBy == null ||
        store.endLongEventsBy == null ||
        store.enableOnlineMeetingsByDefault == null
    ) {
        return true;
    }

    return false;
}
